import React from 'react';
//import logo from './logo.svg';
//redeploy
import './App.css';
import './Analytics.css';
import Home from "./Home";


function App() {
  return (
    <Home></Home>
  );
}

export default App;
